import {match, matchPath} from 'react-router';

export const GALLERY_PATH = '/gallery/:sortOrTag?/:tag?';
export const STORAGE_EXPLORER_TRACKED_PATH =
  '/storage/:entityName/tracked/:filePath*';
export const REPORT_PAGE_VIEW_PATH =
  '/:entityName/:projectName/reports/:reportNameAndID';
export const REPORT_PAGE_VIEW_PUBLISHED_WORK_PATH =
  '/:entityName/published-work/:publishedWorkNameAndID';
export const PROFILE_PATH = '/:entityName';

interface RouteData {
  path: string | string[];
  exact?: true;
  redirect?: string;
}

const ROUTES: RouteData[] = [
  {
    path: '/__test_page',
    exact: true,
  },
  {
    path: '/',
    exact: true,
  },
  {
    path: '/login',
  },
  {
    path: '/logout',
  },
  {
    path: '/trending',
  },
  {
    path: '/home',
    exact: true,
  },
  {
    path: '/home/projects',
    exact: true,
  },
  {
    path: '/projects',
    exact: true,
  },
  {
    path: GALLERY_PATH,
  },
  {
    path: '/__test/simple_error',
    exact: true,
  },
  {
    path: '/users/:userName',
  },
  {
    path: '/signup',
  },
  {
    path: '/change-password',
  },
  {
    path: '/authorize',
  },
  {
    path: '/settings',
    exact: true,
  },
  {
    path: ['/billing', '/subscriptions'],
    exact: true,
  },
  {
    path: '/admin/team',
  },
  {
    path: '/admin/organization',
  },
  {
    path: '/admin/users',
  },
  {
    path: '/admin/license',
  },
  {
    path: '/create-team',
  },
  {
    path: '/teams/:entityName',
  },
  {
    path: [
      '/storage/:entityName',
      STORAGE_EXPLORER_TRACKED_PATH,
      '/storage/:entityName/:filePath*',
    ],
    exact: true,
  },
  {
    path: '/new-project',
  },
  {
    path: '/new-benchmark',
  },
  {
    path: '/:entityname/benchmark/new',
  },
  {
    path: '/:entityName/projects',
    exact: true,
  },
  {
    path: '/:entityName/likes',
    exact: true,
  },
  {
    path: [
      '/:entityName/:projectName/runs/:runName',
      '/:entityName/:projectName/runs/:runName/:tab(files|code)/:filePath*',
      '/:entityName/:projectName/runs/:runName/:tab',
    ],
    exact: true,
  },
  {
    path: [
      '/:entityName/:projectName/groups/:groupName',
      '/:entityName/:projectName/groups/:groupName/:tab',
    ],
    exact: true,
  },
  {
    path: '/:entityName/:projectName/create-sweep',
    exact: true,
  },
  {
    path: [
      '/:entityName/:projectName/sweeps/:sweepName',
      '/:entityName/:projectName/sweeps/:sweepName/:tab',
    ],
    exact: true,
  },
  {
    path: [
      '/:entityName/:projectName/benchmark',
      '/:entityName/:projectName/benchmark/:tab/:threadID?',
    ],
    exact: true,
  },
  // {
  //   path: '/:entityName/published-work',
  //   exact: true,
  // },
  {
    path: '/:entityName/:projectName/reports',
    exact: true,
  },
  {
    path: '/:entityName/:projectName/published',
    exact: true,
  },
  {
    path: '/:entityName/:projectName/reports/:reportNameAndID/edit',
    exact: true,
  },
  {
    path: REPORT_PAGE_VIEW_PATH,
    exact: true,
  },
  {
    path: REPORT_PAGE_VIEW_PUBLISHED_WORK_PATH,
    exact: true,
  },
  {
    path: '/:entityName/:projectName/querydemo',
    exact: true,
  },
  {
    path: [
      '/:entityName/:projectName',
      '/:entityName/:projectName/:tab(overview|workspace|table|reportlist|sweeps|run-queue|artifacts)',
      '/:entityName/:projectName/:tab(artifacts)/:artifactTypeName(new)',
      '/:entityName/:projectName/:tab(artifacts)/:artifactTypeName',
      '/:entityName/:projectName/:tab(artifacts)/:artifactTypeName/:artifactCommitHash(new)',
      '/:entityName/:projectName/:tab(artifacts)/:artifactTypeName/:artifactCollectionName/:artifactCommitHash/:artifactTab(files)/:filePath*',
      '/:entityName/:projectName/:tab(artifacts)/:artifactTypeName/:artifactCollectionName/:artifactCommitHash/:artifactTab?',
      '/:entityName/:projectName/:tab(artifacts)/:artifactTypeName/:artifactCollectionName',
    ],
    exact: true,
  },
  {
    path: '/:entityName/:projectName',
    redirect: '/:entityName/:projectName',
  },
  {
    path: PROFILE_PATH,
    exact: true,
  },
];

export default ROUTES;

function getRouteMatch(path: string): match | null {
  for (const r of ROUTES) {
    const m = matchPath(path, {path: r.path, exact: r.exact});
    if (m != null) {
      return m;
    }
  }
  return null;
}

export function isReportViewPath(path: string): boolean {
  const m = getRouteMatch(path);
  return (
    [REPORT_PAGE_VIEW_PATH, REPORT_PAGE_VIEW_PUBLISHED_WORK_PATH].indexOf(
      m?.path ?? ''
    ) !== -1
  );
}

export function isProfilePath(path: string): boolean {
  const m = getRouteMatch(path);
  return m?.path === PROFILE_PATH;
}
